// georefAr.js — Datos de ubicación de Argentina resilientes a la API GeoRef.
//
// Las 24 provincias son fijas → se bundlean (no dependen de la API).
// Las localidades sí se piden a la API pública GeoRef, pero de forma resiliente:
// solo se cachea una respuesta VÁLIDA. Ante 429/caída devuelve [] y no cachea,
// para reintentar en la próxima (y que el campo degrade a texto libre).

const GEOREF_BASE = "https://apis.datos.gob.ar/georef/api";

// Nombres canónicos de GeoRef (los usa el endpoint de localidades para matchear).
export const PROVINCIAS_AR = [
  "Buenos Aires",
  "Ciudad Autónoma de Buenos Aires",
  "Catamarca",
  "Chaco",
  "Chubut",
  "Córdoba",
  "Corrientes",
  "Entre Ríos",
  "Formosa",
  "Jujuy",
  "La Pampa",
  "La Rioja",
  "Mendoza",
  "Misiones",
  "Neuquén",
  "Río Negro",
  "Salta",
  "San Juan",
  "San Luis",
  "Santa Cruz",
  "Santa Fe",
  "Santiago del Estero",
  "Tierra del Fuego, Antártida e Islas del Atlántico Sur",
  "Tucumán",
];

// Devuelve un array de nombres de localidades para la provincia dada.
// Resiliente: cachea solo respuestas válidas; ante error devuelve [].
export async function fetchLocalidadesAr(provincia) {
  if (!provincia) return [];
  const key = `georef_localidades_${provincia}`;

  const cached = sessionStorage.getItem(key);
  if (cached) {
    try {
      const arr = JSON.parse(cached);
      if (Array.isArray(arr)) return arr;
    } catch {}
  }

  try {
    const res = await fetch(
      `${GEOREF_BASE}/localidades?provincia=${encodeURIComponent(provincia)}&max=5000&campos=nombre&orden=nombre`
    );
    if (!res.ok) return []; // 429 u otro error → no cachear, reintentar luego
    const data = await res.json();
    if (!data || !Array.isArray(data.localidades)) return [];

    const vistos = new Set();
    const nombres = data.localidades
      .map((l) => l.nombre)
      .filter((n) => (n && !vistos.has(n) ? (vistos.add(n), true) : false));

    sessionStorage.setItem(key, JSON.stringify(nombres));
    return nombres;
  } catch {
    return [];
  }
}
